import React, { useEffect, useState } from 'react'
import {
  Box,
  Button,
  Container,
  Grid,
  Paper,
}                                     from '@mui/material'
import { useTranslation }             from 'react-i18next'
import { useNavigate, useParams }     from 'react-router-dom'
import { useApi }                     from '../utils/api'
import { useSnackbar }                from 'notistack'
import AlertSimpleDialog              from '../ui/components/alert-simple-dialog'
import Page                           from '../ui/components/Page'
import { BaseBreadcrumbs }            from '../ui/components/BaseBreadcrumbs'
import ShortFormControl               from '../ui/components/short-form-control'
import Consts                         from '../Consts'

export default function InvestmentTransactionSharePage() {

  const api = useApi()
  const navigate = useNavigate()
  const { serviceId, transactionShareId } = useParams()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()
  const [service, setService] = useState(null)
  const [values, setValues] = useState({
    accounted: '',
    price: 0,
  })
  const [shownDeleteDialog, setShownDeleteDialog] = useState(false)

  useEffect(() => {
    api.service.detail(serviceId).then((response) => setService(response)).catch((err) => {
      console.error(err)
    })
  }, [])

  useEffect(() => {
    (async () => {
      if (!isNaN(transactionShareId)) {
        try{
          let transactionShare = await api.transactionShare.detail(transactionShareId)
          setValues({
            ...transactionShare,
          })
        } catch (e){
          enqueueSnackbar(t('Can\'t load investment transaction share'), {
            variant: "error"
          })
        }
      }
    })()
  }, [transactionShareId])

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value })
  }

  const handleCloseDeleteDialog = (result) => {
    setShownDeleteDialog(false)
    if (result) {
      api.transactionShare.delete(transactionShareId).then(() => {
        enqueueSnackbar(t('Investment transaction share deleted'), {
          variant: 'success'
        })
        navigate(`/services/${serviceId}`)
      }).catch(error => {
        enqueueSnackbar(t('Failed to delete investment transaction share'), {
          variant: 'error'
        })
      })
    }
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    let data = {
      ...values,
      type: Consts.TransactionShare.typeInvestment,
      serviceId: parseInt(serviceId),
    }
    try {
      let transactionShare = await api.transactionShare.save(data)
      navigate(`/services/${serviceId}/investments/${transactionShare.id}`)
      enqueueSnackbar(t('Investment transaction share saved'), {
        variant: 'success'
      })
    } catch (e) {
      enqueueSnackbar(t('Failed to save investment transaction share'), {
        variant: 'error'
      })
    }
  }

  return (
    <Page title={t('Investment transaction share')}>
      <Container component="main">
        <BaseBreadcrumbs key={'breadcrumb-share'}
                         title={values?.name ? values.name : t('Investment transaction share')}
                         items={[
                           { title: t('Services'), href: `/services` },
                           { title: service?.title ?? t('Service'), href: `/services/${serviceId}` }
                         ]}/>
        <Grid component={'form'} onSubmit={onSubmit} item xs={12}>
          <Paper sx={{ p: 2, width: '100%' }}>
            <Grid container sx={{ width: '100%' }} spacing={2}>
              <Grid item xs={12}>
                <ShortFormControl name={'accounted'} title={t('Accounted')} value={values.accounted ?? ''} handleChange={handleChange} inputProps={{ type: 'date' }} />
              </Grid>
              <Grid item xs={12}>
                <ShortFormControl name={'price'} title={t('Price')} value={values.price ?? ''} handleChange={handleChange} inputProps={{ type: 'number' }} />
              </Grid>
            </Grid>
          </Paper>
          <Box sx={{ mt: 2, px: 1 }}>
            <Button type={'submit'} variant={'contained'}>{t('Save')}</Button>
            { !isNaN(transactionShareId) && (<Button type={'button'} color={'error'} variant={'contained'} sx={{ ml: 2 }} onClick={() => { setShownDeleteDialog(true) }}>{t('Delete')}</Button>) }
          </Box>
        </Grid>
        <AlertSimpleDialog
          title={t('Deleting investment')}
          message={t('delete-confirm-msg', { name: values.id })}
          open={shownDeleteDialog}
          onClose={handleCloseDeleteDialog}
        />
      </Container>
    </Page>
  )
}